import React from "react";

type Variant = "pos" | "neg";

export type DynamicSvgIconProps = {
    name: string;
    alt?: string;
    mode?: "light" | "dark";
    viewBox?: string;
    width?: number;
    height?: number;
};

const icons = import.meta.glob<{ default: React.FC<React.SVGProps<SVGSVGElement>> }>("../assets/svgs/*.svg", {
    eager: true,
    query: "react"
});

const buildKey = (name: string, variant?: Variant): string =>
    (variant
        ? Object.keys(icons).find((key) => key.includes(`${name}_${variant}.svg`))
        : Object.keys(icons).find((key) => key.includes(`${name}.svg`))) || "";

export const DynamicSvgIcon: React.FC<DynamicSvgIconProps> = ({ name, width, height, alt = name, mode, viewBox }) => {
    const effectiveVariant = mode === "dark" ? "neg" : "pos";

    // TODO wahrscheinlich können neg/pos varianten auf eine reduziert und per fill-Style gefärbt werden....

    const key = buildKey(name, effectiveVariant) || buildKey(name);

    if (!key || !icons[key]) {
        console.warn(`Icon not found: ${name}_${effectiveVariant}`);
        return null;
    }

    const Icon = icons[key].default;

    return (
        <Icon
            role="img"
            aria-label={alt ?? name}
            width={width}
            height={height}
            style={{
                display: "inline-block",
                verticalAlign: "middle",
                margin: -3
            }}
            viewBox={viewBox}
        />
    );
};
